<template>
    <div id="system">
        <v-card-subtitle class="pb-0">
            <v-icon :color="dangerColor" left>mdi-trash</v-icon><b>Delete Applicant</b> - This feature deletes the
            online residence application for the selected student.
        </v-card-subtitle>
        <v-card-actions class="px-5">
            <v-btn class="white--text" :disabled="!getAccess()" :color="dangerColor" @click="openDeleteDialog()">
                Delete
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="deleteDialog" width="540">
            <v-card>
                <v-card-title>Delete Applicant</v-card-title>
                <v-alert :color="warningColor" tile>
                    <v-icon>mdi-information</v-icon> Please review the following warning below!
                </v-alert>
                <v-card-text class="pb-5">
                    This <b>deletion</b> action <b>cannot</b> be undone. This will permanently delete the Online
                    Residence Application for the student number <b>{{ item.studentnumber }}</b> ({{ item.firstName }}
                    {{ item.lastName }}).
                </v-card-text>
                <v-alert v-if="this.studentNumber.length == 9 && !validStudentNumber" :color="dangerColor"
                    icon="mdi-alert-circle" text>
                    Please type the provided valid student number.
                </v-alert>
                <v-card-text>
                    <v-form ref="deleteApplicantForm" v-model="validDelete" lazy-validation>
                        <v-text-field v-model="studentNumber" class="pb-4"
                            hint="By typing the student number, I understand the consequences of deleting this applicant"
                            outlined :label="`Please type ${item.studentnumber} to confirm`" persistent-hint
                            :rules="studentNumberRules" required>
                        </v-text-field>
                        <v-textarea v-model="reason" auto-grow counter="512" label="Reason" outlined
                            placeholder="Please provide a reason for deleting this applicant" :rules="reasonRules"
                            required>
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="deleteApplicantBtn" :color="dangerColor" :disabled="!validDelete || !validStudentNumber"
                        text @click="deleteApplicant()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeDeleteDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'applicant-system',
    props: {
        item: {
            required: true
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            deleteDialog: false,
            studentNumber: '',
            studentNumberRules: [
                v => !!v || 'Student number is required',
                v => /^\d{9}$/.test(v) || 'Please provide a valid student number (9 digits)',
            ],
            reason: '',
            reasonRules: [
                v => !!v || 'Personal interests is required',
                v => (v && v.length <= 512) || 'Personal interests must be between 1 and 512 characters',
            ],
            validDelete: true
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        deleteApplicant() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?deleteApplicant`;

            // Parse array into string
            formData.append('data', JSON.stringify({
                reason: this.reason
            }));
            formData.append('id', this.item.id);
            formData.append('mode', 'deleteApplicant');

            // Loading button
            this.$refs.deleteApplicantBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-account-remove', `The Applicant has been successfully deleted.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-account-alert', `The Applicant could not be deleted. ${json.message}.`, true);
                    }

                    that.refreshData();
                    that.$refs.deleteApplicantBtn.loading = false;
                    that.closeDeleteDialog();
                    that.closeDialog();
                })
                .catch(function () {
                    that.refreshData();
                    that.$refs.deleteApplicantBtn.loading = false;
                    that.closeDeleteDialog();
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        openDeleteDialog() {
            this.studentNumber = '';
            this.reason = '';
            this.resetValidation();
            this.deleteDialog = true;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetValidation() {
            if (this.$refs.deleteApplicantForm) {
                this.$refs.deleteApplicantForm.resetValidation();
            }
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        },
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        warningColor() {
            return '#ffb822'
        },
        validStudentNumber() {
            if (this.item.studentnumber == this.studentNumber) {
                return true;
            }

            return false;
        }
    }
}
</script>